import { ApplicationEvent } from './application-event.model';
import { ApplicationEventType } from '../constants';

export class ShowTooltipValueAddedServiceApplicationEvent implements ApplicationEvent {
  type = ApplicationEventType.ShowTooltipValueAddedService;

  constructor() {}

  getPayload(): any {
    return {
      category: ApplicationEventType.Interaction,
      label: 'tooltip was clicked',
      action: 'Cart tooltip VAS interaction',
    };
  }
}
